/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VolumeStat,
    VolumeStatFromJSON,
    VolumeStatFromJSONTyped,
    VolumeStatToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeStats
 */
export interface VolumeStats {
    /**
     * 
     * @type {Array<VolumeStat>}
     * @memberof VolumeStats
     */
    usage: Array<VolumeStat>;
}

export function VolumeStatsFromJSON(json: any): VolumeStats {
    return VolumeStatsFromJSONTyped(json, false);
}

export function VolumeStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usage': ((json['usage'] as Array<any>).map(VolumeStatFromJSON)),
    };
}

export function VolumeStatsToJSON(value?: VolumeStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usage': ((value.usage as Array<any>).map(VolumeStatToJSON)),
    };
}


